import { Outlet } from "react-router-dom";
import { NavigationMenuHeader } from "@/components/NavigationMenuHeader";
import { Providers } from "@/providers";
import { Analytics } from "@vercel/analytics/react";

export default function RootLayout() {
  return (
    <Providers>
      <Analytics />
      <NavigationMenuHeader />
      <Outlet />
    </Providers>
  );
}

